export const wrapperStyles = {
  position: 'relative',
  width: '100%',
  height: 'max-content',
};

export const getContentWrapperStyles = ({ isError }) => ({
  height: '100%',

  ...(isError && {
    opacity: '0.5',
    pointerEvents: 'none',
  }),
});

export const errorWrapperStyles = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
  height: '100%',
  width: '100%',
  zIndex: 1,
};
